<template>
    <v-row ref="mainContainer" no-gutters>
        <v-col :cols="!isInvoiceMatrix ? 8 : 12">
            <div ref="previewContainer" class="bg-white rounded-xl ma-5 py-4 pl-4 pr-2">
                <v-row no-gutters class="pb-3">
                    <v-col cols="1" class="px-0 pt-0 pb-1 d-flex align-center">
                        <v-btn-back size="small" @click.stop="back()"> </v-btn-back>
                    </v-col>
                    <v-col cols="2" class="d-flex align-center">
                        <v-text-field-filled
                            readonly
                            label="&#xc9;tat"
                            hide-details
                            :model-value="selectedStatus.text"
                            density="compact"
                            v-sanitize
                        />
                    </v-col>
                    <v-col cols="4" class="d-flex align-center">
                        <v-btn
                            v-if="
                                (isInvoice || isCreditNote) &&
                                (invoice.status === 'VALIDATED' ||
                                    invoice.status === 'BEING_VALIDATED') &&
                                !invoice.document
                            "
                            :loading="isSaving"
                            @click="setConfirmInvoiceFirstStep()"
                            :disabled="disabledCreateDocument"
                            class="ml-2"
                            elevation="0"
                            size="small"
                        >
                            Créer le document pour la facture
                        </v-btn>
                        <!-- <v-btn
                            v-if="
                                (isInvoice || isInvoiceMatrix || isCreditNote) &&
                                invoice.status === 'VALIDATED' &&
                                invoice.document
                            "
                            color="primary"

                            rounded
                             size="small"
                            :loading="regenerateInvoiceDocumentLoading"
                            @click="regenerateInvoiceDocument"
                            class="ml-2"
                            elevation="0"
                        >
                            Regénérer le document pour la facture
                        </v-btn> -->
                        <v-btn
                            @click="acceptInvoice"
                            v-else-if="isQuote && invoice.status === 'VALIDATED'"
                            class="ml-2"
                            elevation="0"
                            size="small"
                        >
                            Accepté par le client
                        </v-btn>
                        <v-btn
                            v-else-if="showValidateButton"
                            :loading="isSaving"
                            @click="
                                showPreviewToggle = false;
                                verifInvoiceDate();
                            "
                            :disabled="disabledValidate"
                            class="ml-2"
                            elevation="0"
                            data-cy="InvoiceEdition-valider"
                            size="small"
                        >
                            Valider
                            <template v-if="isInvoice">la facture</template>
                            <template v-else-if="isInvoiceMatrix">les factures multiples</template>
                            <template v-else-if="isQuote">le devis</template>
                            <template v-else-if="isBillOfDelivery">le BL</template>
                            <template v-else-if="isCreditNote">l'avoir</template>
                        </v-btn>
                        <!-- <v-btn @click="printPreview">Print</v-btn> -->

                        <v-btn
                            class="elevation-0 ml-2"
                            @click="saveInvoice()"
                            :loading="isSaving"
                            v-if="!isLocked && isInvoiceMatrix"
                            size="small"
                        >
                            Enregistrer
                        </v-btn>
                        <v-progress-linear
                            color="primary"
                            height="10"
                            buffer-value="0"
                            v-if="localStepData && localStepData.action !== ''"
                            stream
                            class="ml-2"
                            :model-value="progressValue"
                        />
                    </v-col>
                    <v-col cols="5" class="d-flex justify-end align-center pa-0 mt-1">
                        <TutorialButtonDialog
                            v-if="!$vuetify.display.mobile"
                            :starterComponents="'InvoiceEdition'"
                        />
                        <v-tooltip
                            v-if="
                                invoice.status === 'DRAFT' &&
                                invoice.type !== 'INVOICE_RECURRENT' &&
                                invoice.type !== 'INVOICE_MATRIX'
                            "
                            location="bottom"
                        >
                            <template v-slot:activator="{ props }">
                                <v-btn-icon
                                    :icon="!showPreviewToggle ? '$oss-eye' : '$oss-edit'"
                                    @click="showPreviewToggle = !showPreviewToggle"
                                    v-bind="props"
                                />
                            </template>
                            <span v-if="!showPreviewToggle">Prévisualiser le document</span>
                            <span v-else>Retourner à l'édition</span>
                        </v-tooltip>
                        <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                                <v-btn-icon
                                    icon="$oss-sync"
                                    class="elevation-0 mx-2"
                                    @click="convertDocumentDialog = true"
                                    v-bind="props"
                                    :loading="isSaving"
                                    :disabled="
                                        invoice.status === 'DRAFT' ||
                                        (!!invoice.deposits && !!invoice.deposits.length)
                                    "
                                    v-if="isQuote || isBillOfDelivery"
                                    size="small"
                                />
                            </template>
                            <span>Convertir</span>
                        </v-tooltip>
                        <v-tooltip location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-btn-icon
                                    icon="$oss-letter"
                                    class="elevation-0 mx-2"
                                    v-bind="props"
                                    v-if="isQuote"
                                    :disabled="
                                        !enableSignature || !containsReceivers || !invoice.document
                                    "
                                    @click="askForSignature()"
                                />
                            </template>
                            <span>Signer</span>
                        </v-tooltip>
                        <v-menu v-if="enableSendMail" open-on-hover offset-y location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-btn-icon
                                    icon="$oss-mail"
                                    class="elevation-0 mx-2"
                                    v-bind="props"
                                    @click.stop="getDefaultMailer()"
                                />
                            </template>
                            <v-list v-if="enablePayment || enableSignature">
                                <v-list-item @click="getDefaultMailer()">
                                    Envoyer par mail
                                </v-list-item>
                                <v-list-item v-if="enablePayment" @click="showPayDialog()">
                                    Envoyer par mail avec un lien de paiement
                                </v-list-item>
                                <v-list-item
                                    v-if="enableSignature"
                                    @click="getDefaultMailerWithSignature()"
                                >
                                    Envoyer par mail avec un lien pour signature
                                </v-list-item>
                            </v-list>
                        </v-menu>
                        <v-tooltip v-if="!isNewInvoice" location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-btn-icon
                                    icon="$oss-duplicate"
                                    class="elevation-0 mx-2"
                                    v-bind="props"
                                    :disabled="!!invoice.depositOf"
                                    @click="dialogConfirmDuplicate = true"
                                    data-cy="InvoiceEdition-duplicate"
                                />
                            </template>
                            <span>Dupliquer</span>
                        </v-tooltip>
                        <v-tooltip
                            v-if="
                                !isNewInvoice &&
                                !isRecurrent &&
                                localStepData &&
                                localStepData.action !== 'download'
                            "
                            location="bottom"
                        >
                            <template v-slot:activator="{ props }">
                                <v-btn-icon
                                    icon="$oss-download"
                                    elevation="0"
                                    class="mx-2"
                                    v-bind="props"
                                    @click="printInvoice"
                                    :disabled="disabledDownload"
                                    :loading="downloadLoading"
                                    data-cy="InvoiceEdition-download"
                                />
                            </template>
                            <span>Télécharger</span>
                        </v-tooltip>
                        <v-progress-circular
                            v-if="localStepData && localStepData.action === 'download'"
                            :size="24"
                            rounded
                            :model-value="progressValue"
                        />
                        <v-menu offset-y>
                            <template v-slot:activator="{ props }">
                                <v-btn-icon icon="$dots_vertical" v-bind="props" />
                            </template>
                            <v-list>
                                <v-list-item
                                    @click="dialogCreditNote = true"
                                    data-cy="InvoiceEdition-avoir"
                                    v-if="allowToCreateACreditNote"
                                >
                                    <v-list-item-title>Créer un avoir</v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    v-if="allowToCreateACreditNote"
                                    @click="cancelAndReplaceDialog = true"
                                    data-cy="InvoiceEdition-cancelAndReplaceInvoice"
                                >
                                    <v-list-item-title>Annule et remplace</v-list-item-title>
                                </v-list-item>
                                <v-divider v-if="allowToCreateACreditNote" />
                                <v-list-item
                                    @click="
                                        () =>
                                            !regenerateInvoiceDocumentLoading &&
                                            regenerateInvoiceDocument()
                                    "
                                    v-if="
                                        (isInvoice || isInvoiceMatrix || isCreditNote) &&
                                        invoice.status === 'VALIDATED' &&
                                        invoice.document
                                    "
                                >
                                    <v-list-item-title>
                                        <v-progress-circular
                                            indeterminate
                                            size="16"
                                            width="2"
                                            v-if="regenerateInvoiceDocumentLoading"
                                        />
                                        Regénérer le document
                                    </v-list-item-title>
                                </v-list-item>
                                <v-divider />
                                <v-list-item
                                    :disabled="
                                        !(
                                            !isNewInvoice &&
                                            invoice &&
                                            invoice.status === 'DRAFT' &&
                                            invoice.type !== 'INVOICE_RECURRENT' &&
                                            !isDepositOfInvoice
                                        )
                                    "
                                    @click="dialogDeleteDocument = true"
                                >
                                    <v-list-item-title>Supprimer</v-list-item-title>
                                    <template v-slot:append>
                                        <v-icon size="small">$delete</v-icon>
                                    </template>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-col>

                    <MailerDialog
                        v-model="mailerDialog"
                        :mailType="invoiceDefaultMailerInfos.mailType"
                        :defaultSubject="invoiceDefaultMailerInfos.defaultSubject"
                        :defaultText="invoiceDefaultMailerInfos.defaultText"
                        :companyId="companyId"
                        :thirdPartyCompanyId="invoice.client.id"
                        :defaultReceivers="invoice.data.receivers"
                        :withAttachment="invoiceDefaultMailerInfos.withAttachment"
                        :invoice="[invoice]"
                        :budgetInsightOptions="budgetInsightOptions ? budgetInsightOptions : null"
                        :invoiceData="invoiceData"
                        v-if="mailerDialog"
                    />
                </v-row>
                <div
                    style="overflow-y: auto; height: calc(100vh - 192px); overflow-x: hidden"
                    class="pr-1"
                >
                    <v-row no-gutters>
                        <v-window
                            v-model="preview"
                            class="elevation-0"
                            horizontal
                            style="width: 100%"
                        >
                            <v-window-item :value="0" :key="0">
                                <v-col cols="12">
                                    <div class="elevation-0">
                                        <!-- <div class="mx-0 px-0 font-weight-bold" v-if="isCreditNote">
                                            <v-btn
                                                 size="small"
                                                rounded
                                                color="primary"

                                                elevation="0"
                                                class="ml-2"
                                                v-if="isCreditNote"
                                                @click="
                                                    $router.push({
                                                        name: 'invoiceEdition',
                                                        params: {
                                                            id: invoice.creditNoteOf.id,
                                                            companyId: companyId,
                                                        },
                                                    })
                                                "
                                            >
                                                Voir la facture
                                            </v-btn>
                                        </div> -->
                                        <div class="border rounded-xl pa-3">
                                            <v-row no-gutters>
                                                <v-col cols="4" class="d-flex align-center">
                                                    <div class="subtitle-1 font-weight-bold w-100">
                                                        <template v-if="isInvoiceMatrix"
                                                            >Factures multiples</template
                                                        >
                                                        <template v-else-if="isRecurrent"
                                                            >Facture récurrente</template
                                                        >
                                                        <template
                                                            v-else-if="
                                                                isInvoice &&
                                                                (isLocked || isDepositOfInvoice)
                                                            "
                                                            >Facture</template
                                                        >
                                                        <template
                                                            v-else-if="isCreditNote && isLocked"
                                                            >Avoir de facture</template
                                                        >
                                                        <template
                                                            v-else-if="isInvoice || isCreditNote"
                                                        >
                                                            <v-select-filled
                                                                v-model="invoice.type"
                                                                :items="[
                                                                    {
                                                                        title: 'Facture',
                                                                        value: 'INVOICE',
                                                                    },
                                                                    {
                                                                        title: 'Avoir de Facture',
                                                                        value: 'CREDIT_NOTE',
                                                                    },
                                                                ]"
                                                                item-value="value"
                                                                hide-details
                                                                class="font-weight-normal mr-2"
                                                                :disabled="
                                                                    isDepositOfInvoice || isLocked
                                                                "
                                                                data-cy="InvoiceEdition-invoice.type"
                                                                density="compact"
                                                                item-title="title"
                                                            />
                                                        </template>
                                                        <!-- <template v-else-if="isCreditNote">Avoir de facture</template> -->
                                                        <template v-else-if="isQuote"
                                                            >Devis</template
                                                        >
                                                        <template v-else-if="isBillOfDelivery"
                                                            >Bon de livraison</template
                                                        >
                                                    </div>
                                                </v-col>
                                                <v-col cols="8">
                                                    <v-text-field-filled
                                                        label="Titre"
                                                        hide-details
                                                        v-model="invoice.title"
                                                        :readonly="isLocked"
                                                        density="compact"
                                                        v-sanitize
                                                    />
                                                </v-col>
                                                <v-col
                                                    cols="12"
                                                    class="py-2"
                                                    v-if="
                                                        !isRecurrent && !isInvoice && !isCreditNote
                                                    "
                                                >
                                                    <v-divider />
                                                </v-col>
                                                <v-col
                                                    cols="12"
                                                    class="pt-4 d-flex align-center"
                                                    v-if="
                                                        !isRecurrent && !isInvoice && !isCreditNote
                                                    "
                                                >
                                                    <div class="mr-1 w-25">
                                                        <oss-date-picker-filled
                                                            :readonly="isLocked"
                                                            v-model="invoice.date"
                                                            label="Date d'émission"
                                                            hide-details
                                                            :textFieldReadOnly="false"
                                                            :filterWithoutClosedAccountingPeriods="
                                                                !isLocked
                                                            "
                                                            :min-date="
                                                                isLocked
                                                                    ? undefined
                                                                    : lastDateInvoice
                                                            "
                                                            @update:model-value="
                                                                onDateChanged($event)
                                                            "
                                                        />
                                                    </div>
                                                    <div
                                                        v-if="
                                                            isInvoice || isInvoiceMatrix || isQuote
                                                        "
                                                        class="ml-1 w-25"
                                                    >
                                                        <oss-date-picker-filled
                                                            :readonly="isLocked"
                                                            v-model="invoice.dueDate"
                                                            :filterWithoutClosedAccountingPeriods="
                                                                !isLocked
                                                            "
                                                            label="Date d'échéance"
                                                            hide-details
                                                            :textFieldReadOnly="false"
                                                            :min-date="invoice.date"
                                                        />
                                                    </div>
                                                    <div v-if="isInvoiceMatrix || isInvoice">
                                                        <v-col class="d-flex">
                                                            <v-switch
                                                                v-model="invoice.autoValidation"
                                                                label="Validation auto"
                                                                hide-details
                                                                class="mt-0"
                                                                :readonly="isLocked"
                                                            />
                                                        </v-col>
                                                    </div>
                                                    <div v-if="isInvoiceMatrix || isInvoice">
                                                        <v-col>
                                                            <v-switch
                                                                v-model="
                                                                    invoice.sendEmailAfterValidation
                                                                "
                                                                label="Envoyer un mail"
                                                                hide-details
                                                                class="mt-0"
                                                                :readonly="isLocked"
                                                            />
                                                        </v-col>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <template v-if="!isInvoiceMatrix">
                                            <v-form v-model="areRulesValid">
                                                <v-divider class="mb-2" />
                                                <v-row no-gutters v-if="!invoice.lines.length">
                                                    <v-col cols="12" class="d-flex justify-center">
                                                        Aucune ligne comptable
                                                    </v-col>
                                                </v-row>
                                                <draggable
                                                    v-model="invoice.lines"
                                                    handle=".handle"
                                                    animation="300"
                                                    itemKey="id"
                                                >
                                                    <template #item="{ element: line, index }">
                                                        <v-row no-gutters :key="index" class="mb-2">
                                                            <v-col
                                                                cols="1"
                                                                class="handle d-flex justify-center align-center"
                                                            >
                                                                <v-icon
                                                                    color="#AAA"
                                                                    size="x-small"
                                                                    style="cursor: move"
                                                                    v-if="
                                                                        !isLocked &&
                                                                        !isDepositOfInvoice
                                                                    "
                                                                    >$fa-grip-vertical</v-icon
                                                                >
                                                            </v-col>
                                                            <!-- <v-col class="flex-grow-1 flex-shrink-0"> -->
                                                            <v-col
                                                                cols="11"
                                                                v-if="line.type !== 'TOTAL'"
                                                            >
                                                                <v-row no-gutters>
                                                                    <v-col cols="2">
                                                                        <oss-text-field-filled
                                                                            v-model="line.quantity"
                                                                            label="Quantité"
                                                                            :readonly="
                                                                                isLocked ||
                                                                                isDepositOfInvoice
                                                                            "
                                                                            outlined
                                                                            hide-details
                                                                            dense
                                                                            @update:model-value="
                                                                                updateLineAmounts(
                                                                                    line,
                                                                                )
                                                                            "
                                                                            v-if="
                                                                                !incomeIsDiscount(
                                                                                    line,
                                                                                )
                                                                            "
                                                                            v-sanitize
                                                                        />
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="2"
                                                                        v-if="
                                                                            !incomeIsDiscount(
                                                                                line,
                                                                            ) && !areAllDepositLines
                                                                        "
                                                                        class="pl-2"
                                                                    >
                                                                        <oss-text-field-filled
                                                                            v-model="line.unitPrice"
                                                                            :label="unitPriceLabel"
                                                                            :readonly="
                                                                                isLocked ||
                                                                                isDepositOfInvoice
                                                                            "
                                                                            outlined
                                                                            hide-details
                                                                            dense
                                                                            suffix="&#x20ac;"
                                                                            @update:model-value="
                                                                                updateLineAmounts(
                                                                                    line,
                                                                                )
                                                                            "
                                                                            v-sanitize
                                                                        />
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="2"
                                                                        class="pl-2"
                                                                        v-if="!areAllDepositLines"
                                                                    >
                                                                        <v-select-filled
                                                                            :items="vatList"
                                                                            v-model.number="
                                                                                line.vatRate
                                                                            "
                                                                            item-title="text"
                                                                            label="Taux de TVA"
                                                                            item-value="value"
                                                                            hide-details
                                                                            readonly
                                                                            @update:model-value="
                                                                                updateLineAmounts(
                                                                                    line,
                                                                                )
                                                                            "
                                                                            v-if="
                                                                                !incomeIsDiscount(
                                                                                    line,
                                                                                )
                                                                            "
                                                                            density="compact"
                                                                        />
                                                                    </v-col>
                                                                    <v-col
                                                                        :cols="
                                                                            areAllDepositLines
                                                                                ? '10'
                                                                                : '3'
                                                                        "
                                                                        class="pl-2"
                                                                    >
                                                                        <v-text-field-filled
                                                                            label="Montant HT"
                                                                            readonly
                                                                            hide-details
                                                                            v-if="
                                                                                !displayTTCAmounts
                                                                            "
                                                                            :model-value="
                                                                                newCommonFormatCurrency(
                                                                                    line.netAmount,
                                                                                    undefined,
                                                                                )
                                                                            "
                                                                            density="compact"
                                                                            v-sanitize
                                                                        />
                                                                        <v-text-field-filled
                                                                            label="Montant TTC"
                                                                            readonly
                                                                            hide-details
                                                                            v-else
                                                                            :model-value="
                                                                                newCommonFormatCurrency(
                                                                                    line.grossAmount,
                                                                                    undefined,
                                                                                )
                                                                            "
                                                                            density="compact"
                                                                            v-sanitize
                                                                        />
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="3"
                                                                        class="pl-2"
                                                                        v-if="!isDeposit"
                                                                    >
                                                                        <div class="d-flex">
                                                                            <v-select-filled
                                                                                v-model="
                                                                                    line.discountType
                                                                                "
                                                                                :items="[
                                                                                    '%',
                                                                                    '&#x20ac;',
                                                                                ]"
                                                                                label="Remise"
                                                                                hide-details
                                                                                @update:model-value="
                                                                                    resetOtherDiscountType(
                                                                                        line,
                                                                                    )
                                                                                "
                                                                                density="compact"
                                                                            />
                                                                            <div
                                                                                class="d-flex flex-row flex-grow-1"
                                                                            >
                                                                                <oss-text-field-filled
                                                                                    v-model="
                                                                                        line.discountPercentage
                                                                                    "
                                                                                    :text="
                                                                                        limit2decimals(
                                                                                            line.discountPercentage,
                                                                                        )
                                                                                    "
                                                                                    label="Remise"
                                                                                    suffix="%"
                                                                                    :readonly="
                                                                                        isLocked
                                                                                    "
                                                                                    :rules="[
                                                                                        rules.isPercentage,
                                                                                    ]"
                                                                                    :key="
                                                                                        'fieldDiscountPercentage_' +
                                                                                        index +
                                                                                        '_' +
                                                                                        expandKey
                                                                                    "
                                                                                    class="ml-2 flex-grow-1"
                                                                                    hide-details
                                                                                    v-if="
                                                                                        line.discountType ===
                                                                                        '%'
                                                                                    "
                                                                                    v-sanitize
                                                                                />
                                                                                <oss-text-field-filled
                                                                                    v-model="
                                                                                        line.discount
                                                                                    "
                                                                                    label="Remise"
                                                                                    class="ml-2 flex-grow-1"
                                                                                    suffix="&#x20ac;"
                                                                                    :readonly="
                                                                                        isLocked
                                                                                    "
                                                                                    :rules="[
                                                                                        rules.isCorrectAmount,
                                                                                    ]"
                                                                                    :key="
                                                                                        'fieldDiscount_' +
                                                                                        index +
                                                                                        '_' +
                                                                                        expandKey
                                                                                    "
                                                                                    hide-details
                                                                                    v-else
                                                                                    v-sanitize
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row no-gutters class="pt-1">
                                                                    <v-col cols="2">
                                                                        <v-text-field-filled
                                                                            v-model="line.reference"
                                                                            :readonly="
                                                                                isLocked ||
                                                                                isDepositOfInvoice
                                                                            "
                                                                            hide-details
                                                                            label="Référence"
                                                                            density="compact"
                                                                            v-sanitize
                                                                        />
                                                                    </v-col>
                                                                    <v-col :cols="'7'" class="pl-2">
                                                                        <v-text-field-filled
                                                                            v-model="line.title"
                                                                            :readonly="isLocked"
                                                                            hide-details
                                                                            label="Nom"
                                                                            density="compact"
                                                                            v-sanitize
                                                                        />
                                                                    </v-col>

                                                                    <v-col
                                                                        :cols="'3'"
                                                                        class="d-flex justify-end"
                                                                    >
                                                                        <v-checkbox
                                                                            v-if="isQuote"
                                                                            v-model="
                                                                                line.isOptional
                                                                            "
                                                                            label="En option"
                                                                            :readonly="isLocked"
                                                                            color="primary"
                                                                        />
                                                                        <v-btn-icon
                                                                            :icon="
                                                                                !line.expand
                                                                                    ? '$fa-chevron-down'
                                                                                    : '$fa-chevron-up'
                                                                            "
                                                                            @click="
                                                                                line.expand =
                                                                                    !line.expand;
                                                                                expandKey++;
                                                                            "
                                                                            size="small"
                                                                        />

                                                                        <v-btn-trash
                                                                            v-if="
                                                                                !isLocked &&
                                                                                !isDepositOfInvoice
                                                                            "
                                                                            size="small"
                                                                            @click="
                                                                                removeInvoiceLine(
                                                                                    index,
                                                                                )
                                                                            "
                                                                        />
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row no-gutters class="pt-1">
                                                                    <v-col
                                                                        cols="12"
                                                                        :key="
                                                                            'expandedLine_' +
                                                                            index +
                                                                            '_' +
                                                                            expandKey
                                                                        "
                                                                        v-if="line.expand"
                                                                    >
                                                                        <v-textarea-filled
                                                                            label="Description"
                                                                            v-model="
                                                                                line.description
                                                                            "
                                                                            :readonly="
                                                                                isLocked ||
                                                                                isDepositOfQuotation
                                                                            "
                                                                            hide-details
                                                                            rows="1"
                                                                            auto-grow
                                                                            density="default"
                                                                            v-sanitize
                                                                        />
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                            <v-col cols="11" v-else>
                                                                <v-row no-gutters>
                                                                    <v-col cols="7" />
                                                                    <v-col cols="2">
                                                                        <div
                                                                            class="totals text-right"
                                                                        >
                                                                            <span>
                                                                                Sous-total HT
                                                                            </span>
                                                                            <br />
                                                                            <span>
                                                                                Sous-total TTC
                                                                            </span>
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col cols="1" />
                                                                    <v-col cols="1">
                                                                        <div
                                                                            class="totals text-right justify-end"
                                                                        >
                                                                            <span>
                                                                                <!-- {{
                                                                                    newCommonFormatCurrency(
                                                                                        formattedLines[
                                                                                            index
                                                                                        ].netAmount,
                                                                                        undefined,
                                                                                    )
                                                                                }} -->
                                                                                {{
                                                                                    newCommonFormatCurrency(
                                                                                        line.netAmount,
                                                                                        undefined,
                                                                                    )
                                                                                }}
                                                                            </span>
                                                                            <br />
                                                                            <span>
                                                                                <!-- {{
                                                                                    newCommonFormatCurrency(
                                                                                        formattedLines[
                                                                                            index
                                                                                        ]
                                                                                            .grossAmount,
                                                                                        undefined,
                                                                                    )
                                                                                }} -->
                                                                                {{
                                                                                    newCommonFormatCurrency(
                                                                                        line.grossAmount,
                                                                                        undefined,
                                                                                    )
                                                                                }}
                                                                            </span>
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="1"
                                                                        class="d-flex flex-row justify-end"
                                                                    >
                                                                        <v-btn-trash
                                                                            v-if="!isLocked"
                                                                            class="pl-1"
                                                                            @click="
                                                                                removeInvoiceLine(
                                                                                    index,
                                                                                )
                                                                            "
                                                                        />
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                    </template>
                                                </draggable>
                                                <v-divider />
                                                <v-row
                                                    no-gutters
                                                    class="pt-2 pb-2"
                                                    v-if="!isDeposit"
                                                >
                                                    <v-col cols="12">
                                                        <v-row
                                                            no-gutters
                                                            class="d-flex justify-end"
                                                        >
                                                            <v-col cols="5" class="pl-2">
                                                                <div class="d-flex">
                                                                    <v-select-filled
                                                                        v-model="globalDiscountType"
                                                                        :items="['%', '&#x20ac;']"
                                                                        label="Remise"
                                                                        class="pr-2 d-flex flex-grow-0 flex-shrink-1"
                                                                        hide-details
                                                                        :readonly="isLocked"
                                                                        @update:model-value="
                                                                            resetOtherDiscountType()
                                                                        "
                                                                        density="compact"
                                                                        v-sanitize
                                                                    />
                                                                    <div
                                                                        class="d-flex flex-row flex-grow-1"
                                                                    >
                                                                        <oss-text-field-filled
                                                                            v-model="
                                                                                invoice.discountPercentage
                                                                            "
                                                                            label="Remise"
                                                                            class="flex-grow-1"
                                                                            suffix="%"
                                                                            :key="
                                                                                'glDiscountPerce_' +
                                                                                expandKey
                                                                            "
                                                                            :readonly="isLocked"
                                                                            hide-details
                                                                            :rules="[
                                                                                rules.isPercentage,
                                                                            ]"
                                                                            v-if="
                                                                                globalDiscountType ===
                                                                                '%'
                                                                            "
                                                                            v-sanitize
                                                                        />
                                                                        <oss-text-field-filled
                                                                            v-model="
                                                                                invoice.discount
                                                                            "
                                                                            label="Remise"
                                                                            class="flex-grow-1"
                                                                            suffix="&#x20ac;"
                                                                            :key="
                                                                                'glDiscount_' +
                                                                                expandKey
                                                                            "
                                                                            :readonly="isLocked"
                                                                            :rules="[
                                                                                rules.isCorrectAmount,
                                                                            ]"
                                                                            hide-details
                                                                            v-else
                                                                            v-sanitize
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                                <v-row no-gutters align="start" class="pt-2">
                                                    <v-col cols="6">
                                                        <template
                                                            v-if="!isLocked && !isDepositOfInvoice"
                                                        >
                                                            <div class="d-flex">
                                                                <v-row no-gutters>
                                                                    <v-col cols="6">
                                                                        <InvoiceProductsDialog
                                                                            :companyId="companyId"
                                                                            :canBeOptionnal="
                                                                                isQuote
                                                                            "
                                                                            @valid="addLine($event)"
                                                                        >
                                                                            <template
                                                                                v-slot:activator="{
                                                                                    props,
                                                                                }"
                                                                            >
                                                                                <v-btn
                                                                                    elevation="0"
                                                                                    v-bind="props"
                                                                                    size="small"
                                                                                >
                                                                                    Ajouter un
                                                                                    produit
                                                                                    <v-icon
                                                                                        right
                                                                                        class="ml-2"
                                                                                        >$add</v-icon
                                                                                    >
                                                                                </v-btn>
                                                                            </template>
                                                                        </InvoiceProductsDialog>
                                                                    </v-col>
                                                                    <!-- <v-col cols="1"></v-col> -->
                                                                    <v-col cols="6">
                                                                        <v-btn
                                                                            elevation="0"
                                                                            @click.stop="
                                                                                addSubtTotalLine()
                                                                            "
                                                                            data-cy="InvoiceEdition-addSousTotal"
                                                                            size="small"
                                                                        >
                                                                            Ajouter un sous-total
                                                                            <v-icon
                                                                                right
                                                                                class="ml-2"
                                                                                >$add</v-icon
                                                                            >
                                                                        </v-btn>
                                                                    </v-col>
                                                                </v-row>
                                                                <!-- <oss-dialog
                                                            v-model="dialogInvoiceDiscount"
                                                            title="Remise"
                                                            width="50%"
                                                            :valid-disabled="!isValidDiscount"
                                                            @previous="goToMainPageInvoiceDiscount()"
                                                            @valid="addInvoiceDiscount()"
                                                        >
                                                            <template #activator="{ on }">
                                                                <v-btn
                                                                    rounded

                                                                    elevation="0"
                                                                     size="small"
                                                                    color="primary"
                                                                    class="ml-2"
                                                                    v-on="on"
                                                                >
                                                                    Ajouter une remise
                                                                    <v-icon right>$add</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <template #content>
                                                                <div class="py-2">
                                                                    <InvoiceDiscount
                                                                        ref="invoiceDiscount"
                                                                        @is-valid="isValidDiscount = $event"
                                                                    ></InvoiceDiscount>
                                                                </div>
                                                            </template>
                                                        </oss-dialog> -->
                                                            </div>
                                                            <div class="py-3">
                                                                <v-row v-if="selectVATType">
                                                                    <v-col cols="6">
                                                                        <v-select-filled
                                                                            v-model="
                                                                                invoice.vatType
                                                                            "
                                                                            :items="vatTypes"
                                                                            label="Type de TVA"
                                                                            item-key="key"
                                                                            item-value="value"
                                                                            item-title="text"
                                                                            hide-details
                                                                            density="compact"
                                                                        />
                                                                    </v-col>
                                                                </v-row>
                                                            </div>
                                                        </template>
                                                    </v-col>
                                                    <v-col cols="3">
                                                        <div class="text-right">
                                                            <span v-if="subjectToVAT" />
                                                            <br
                                                                v-if="
                                                                    subjectToVAT &&
                                                                    !displayAllVatRateTotals
                                                                "
                                                            />
                                                            <span
                                                                v-if="
                                                                    subjectToVAT &&
                                                                    !displayAllVatRateTotals
                                                                "
                                                            />
                                                            <template
                                                                v-if="
                                                                    subjectToVAT &&
                                                                    displayAllVatRateTotals
                                                                "
                                                            >
                                                                <br
                                                                    v-for="(
                                                                        vatTotal, vatTotalIndex
                                                                    ) in vatAmountTotals"
                                                                    :key="
                                                                        'vatTotalRateEmpty_' +
                                                                        vatTotalIndex
                                                                    "
                                                                />
                                                                <!-- <div
                                                                    v-for="(vatTotal, vatTotalIndex) in vatAmountTotals" :key="'vatTotalRateEmpty_' + vatTotalIndex"
                                                                ></div> -->
                                                            </template>
                                                            <v-switch
                                                                v-model="depositSwitch"
                                                                label="Avec acomptes"
                                                                class="pt-0 pl-2"
                                                                v-if="displayDepositSwitch"
                                                                :readonly="isLocked"
                                                                data-cy="InvoiceEdition-acomptes"
                                                            />
                                                        </div>
                                                    </v-col>
                                                    <v-col v-if="!isBillOfDelivery">
                                                        <div class="totals text-right">
                                                            <span v-if="subjectToVAT">
                                                                Total HT
                                                            </span>
                                                            <br
                                                                v-if="
                                                                    subjectToVAT &&
                                                                    !displayAllVatRateTotals
                                                                "
                                                            />
                                                            <span
                                                                v-if="
                                                                    subjectToVAT &&
                                                                    !displayAllVatRateTotals
                                                                "
                                                                style="font-weight: normal"
                                                            >
                                                                Total TVA
                                                            </span>
                                                            <br />
                                                            <template
                                                                v-if="
                                                                    subjectToVAT &&
                                                                    displayAllVatRateTotals
                                                                "
                                                            >
                                                                <div
                                                                    style="
                                                                        font-size: 0.95em;
                                                                        font-weight: normal;
                                                                    "
                                                                    v-for="(
                                                                        vatTotal, vatTotalIndex
                                                                    ) in vatAmountTotals"
                                                                    :key="
                                                                        'vatTotalRate_' +
                                                                        vatTotalIndex
                                                                    "
                                                                >
                                                                    {{
                                                                        "TVA (" +
                                                                        vatTotal.vatRate +
                                                                        "%)"
                                                                    }}
                                                                </div>
                                                            </template>
                                                            <span
                                                                :class="
                                                                    isAvailablePriceForCreditNote
                                                                        ? ''
                                                                        : 'text-red'
                                                                "
                                                            >
                                                                Total
                                                                {{ subjectToVAT ? "TTC" : "" }}
                                                            </span>
                                                            <br />
                                                        </div>
                                                    </v-col>
                                                    <!-- {{
                                                        {
                                                            netAmountTotal,
                                                            subjectToVAT,
                                                            displayAllVatRateTotals,
                                                            vatAmountTotal,
                                                            vatAmountTotals,
                                                            grossAmountTotal,
                                                        }
                                                    }} -->
                                                    <v-col v-if="!isBillOfDelivery">
                                                        <div class="totals text-right">
                                                            <span v-if="subjectToVAT">
                                                                {{
                                                                    newCommonFormatCurrency(
                                                                        netAmountTotal,
                                                                        undefined,
                                                                    )
                                                                }}
                                                            </span>
                                                            <br
                                                                v-if="
                                                                    subjectToVAT &&
                                                                    !displayAllVatRateTotals
                                                                "
                                                            />
                                                            <span
                                                                v-if="
                                                                    subjectToVAT &&
                                                                    !displayAllVatRateTotals
                                                                "
                                                                style="
                                                                    font-size: 0.95em;
                                                                    font-weight: normal;
                                                                "
                                                            >
                                                                {{
                                                                    newCommonFormatCurrency(
                                                                        vatAmountTotal,
                                                                        undefined,
                                                                    )
                                                                }}
                                                            </span>
                                                            <br />
                                                            <template
                                                                v-if="
                                                                    subjectToVAT &&
                                                                    displayAllVatRateTotals
                                                                "
                                                            >
                                                                <div
                                                                    style="
                                                                        font-size: 0.95em;
                                                                        font-weight: normal;
                                                                    "
                                                                    v-for="(
                                                                        vatTotal, vatTotalIndex
                                                                    ) in vatAmountTotals"
                                                                    :key="
                                                                        'vatTotalAmount_' +
                                                                        vatTotalIndex
                                                                    "
                                                                >
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            -vatTotal.vatAmount,
                                                                            undefined,
                                                                        )
                                                                    }}
                                                                </div>
                                                            </template>
                                                            <span
                                                                :class="
                                                                    isAvailablePriceForCreditNote
                                                                        ? ''
                                                                        : 'text-red'
                                                                "
                                                            >
                                                                {{
                                                                    newCommonFormatCurrency(
                                                                        grossAmountTotal,
                                                                        undefined,
                                                                    )
                                                                }}
                                                            </span>
                                                            <br />
                                                        </div>
                                                    </v-col>
                                                </v-row>
                                                <v-card
                                                    class="ml-1 mb-2 elevation-0"
                                                    v-if="depositSwitch"
                                                >
                                                    <v-divider />
                                                    <!-- <CreateDeposit
                                                        v-model="depositIsValid"
                                                        :invoice="invoice"
                                                        :grossAmountTotal="grossAmountTotal"
                                                        :fromQuotation="false"
                                                        @newDeposits-updated="newDeposits = $event"
                                                        @isValid-updated="depositIsValid = $event"
                                                    /> -->
                                                    <CreateDeposit
                                                        v-model="depositIsValid"
                                                        :invoice="invoice"
                                                        :grossAmountTotal="grossAmountTotal"
                                                        :fromQuotation="false"
                                                        @newDeposits-updated="newDeposits = $event"
                                                    />
                                                    <v-divider />
                                                </v-card>
                                            </v-form>
                                        </template>
                                        <InvoiceMatrix
                                            :invoice="invoice"
                                            :invoiceData="invoiceMatrixData"
                                            :readonly="isLocked"
                                            v-else
                                        >
                                        </InvoiceMatrix>
                                        <v-row no-gutters class="py-2">
                                            <v-col cols="12">
                                                <v-textarea-filled
                                                    v-if="!isBillOfDelivery"
                                                    label="Mode de paiement"
                                                    data-cy="invoiceEdition-payment-type"
                                                    v-model="invoice.data.paymentMode"
                                                    v-sanitize
                                                    :readonly="isLocked"
                                                    rows="3"
                                                    auto-grow
                                                />
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters class="py-2">
                                            <v-col cols="12">
                                                <v-textarea-filled
                                                    v-if="!isBillOfDelivery"
                                                    label="Détails du paiement"
                                                    v-model="invoice.data.paymentDetails"
                                                    v-sanitize
                                                    :readonly="isLocked"
                                                    rows="3"
                                                    auto-grow
                                                />
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters class="py-2">
                                            <v-col cols="12">
                                                <v-textarea-filled
                                                    label="Commentaire complémentaire"
                                                    v-model="invoice.data.additionalComment"
                                                    :readonly="isLocked"
                                                    v-sanitize
                                                    rows="3"
                                                    auto-grow
                                                />
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters class="py-2">
                                            <v-col cols="12">
                                                <v-textarea-filled
                                                    label="Mentions légales*"
                                                    v-model="invoice.data.legalText"
                                                    :readonly="isLocked"
                                                    rows="3"
                                                    auto-grow
                                                    v-sanitize
                                                    :rules="[rules.notEmpty]"
                                                />
                                            </v-col>
                                            <v-col cols="12" class="text-right pt-2">
                                                <v-btn
                                                    elevation="0"
                                                    @click.stop="setDefaultLegalForm()"
                                                    v-if="!isLocked"
                                                    data-cy="InvoiceEdition-mentions"
                                                    size="small"
                                                >
                                                    Mentions Légales par défaut
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters class="py-2">
                                            <v-col cols="12">
                                                <v-textarea-filled
                                                    label="Commentaire interne (non visible à l'édition de la facture)"
                                                    v-model="invoice.data.internalComment"
                                                    :readonly="isLocked"
                                                    rows="3"
                                                    auto-grow
                                                    v-sanitize
                                                />
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-col>
                            </v-window-item>
                            <v-window-item :value="1" :key="1">
                                <v-col cols="12 mx-auto">
                                    <InvoiceHtmlTemplateView
                                        ref="invoicePreviewRef"
                                        :invoiceThemeSettings="invoiceThemeSettings"
                                        :invoiceData="invoice"
                                        :quotation="quotation"
                                        :forPrint="false"
                                        :previewScaleSize="previewScaleSize"
                                        :company="userCompany"
                                        @html-generated="(html) => (generatedHtml = html)"
                                        :backgroundImage="backgroundImage"
                                        :additionalDocument="additionalDocument"
                                        :key="preview"
                                        v-if="preview === 1"
                                        @dom-info="invoiceDomInfo = $event"
                                    />
                                </v-col>
                            </v-window-item>
                        </v-window>
                    </v-row>
                </div>
            </div>
        </v-col>
        <v-col cols="4" class="d-flex align-items-end flex-column mt-5" v-if="!isInvoiceMatrix">
            <div
                class="bg-white rounded-xl mr-3 py-3 mb-2 ml-0"
                v-if="isRecurrent || isInvoice || isCreditNote"
            >
                <v-card-title style="padding-top: 5px; padding-bottom: 5px">
                    <v-row no-gutters>
                        <v-col cols="8" class="text-medium-emphasis text-subtitle-1 pb-4">
                            <template v-if="isRecurrent">Facture récurrente</template>
                            <template v-else-if="invoice.number">{{ invoice.number }}</template>
                            <template v-else-if="isInvoice">Facture</template>
                            <template v-else-if="isCreditNote">Avoir</template>
                        </v-col>
                        <!-- <v-col
                            cols="1"
                            class="d-flex justify-end"
                        >
                            <v-tooltip bottom v-if="isRecurrent && !isLocked">
                                <template v-slot:activator="{ on, props }">
                                    <v-btn
                                        color="primary"
                                        icon
                                         size="small"
                                        v-bind="props"
                                        v-on="on"
                                        @click="fromRecurrenceToNormalInvoice()"
                                    >
                                        <v-icon>$fa-rotate-right</v-icon>
                                    </v-btn>
                                </template>
                                <span>Enlever la notion de récurrence</span>
                            </v-tooltip>
                        </v-col> -->
                        <v-col cols="4" class="d-flex justify-end">
                            <v-tooltip v-if="!isLocked && isRecurrent" location="bottom">
                                <template v-slot:activator="{ props }">
                                    <v-btn
                                        elevation="0"
                                        size="small"
                                        v-bind="props"
                                        @click="reccurencyDialog = true"
                                    >
                                        &#xc9;diter <v-icon size="small" right>$edit</v-icon>
                                    </v-btn>
                                </template>
                                <span>&#xc9;diter la récurrence</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text class="pb-1">
                    <v-row no-gutters class="pb-2" v-if="isRecurrent">
                        <v-col cols="12">
                            Date de début de facturation :
                            {{ invoice.startDate ? formatDate(invoice.startDate) : "" }}
                        </v-col>
                        <v-col cols="12" v-if="!isInfinitReccurency">
                            Date de fin de facturation :
                            {{ invoice.endDate ? formatDate(invoice.endDate) : "" }}
                        </v-col>
                        <v-col cols="12" v-else>
                            <div>Sans date de fin</div>
                        </v-col>
                        <v-col cols="12">
                            Périodicité :
                            {{ invoice.periodicity ? formatPeriodicity(invoice.periodicity) : "" }}
                        </v-col>
                        <v-col cols="12" v-if="!isInfinitReccurency">
                            <div>
                                {{ sumUpReccurency() }}
                            </div>
                        </v-col>
                        <v-col cols="12"> Delai de paiement : {{ formatDueDate }} </v-col>
                    </v-row>
                    <v-row no-gutters class="pb-2" v-else>
                        <v-col cols="6" class="pr-1">
                            <oss-date-picker-filled
                                :readonly="isLocked"
                                v-model="invoice.date"
                                label="Date d'émission"
                                hide-details
                                :textFieldReadOnly="false"
                                :filterWithoutClosedAccountingPeriods="!isLocked"
                                :min-date="lastDateInvoice"
                                @update:model-value="onDateChanged($event)"
                                data-cy="InvoiceEdition-dateEmission"
                            />
                        </v-col>
                        <v-col cols="6" class="pl-1" v-if="isInvoice || isInvoiceMatrix || isQuote">
                            <v-tooltip>
                                <template v-slot:activator="{ props }">
                                    <oss-date-picker-filled
                                        :readonly="isLocked"
                                        v-model="invoice.dueDate"
                                        label="Date d'échéance"
                                        hide-details
                                        :textFieldReadOnly="false"
                                        :filterWithoutClosedAccountingPeriods="!isLocked"
                                        :min-date="invoice.date"
                                        v-bind="props"
                                    />
                                </template>
                                <span
                                    >Lors de la validation, un mail sera automatiquement envoyé au
                                    destinataire ci-dessous</span
                                >
                            </v-tooltip>
                        </v-col>
                    </v-row>
                    <v-divider />
                    <v-row no-gutters class="py-2">
                        <v-col v-if="isRecurrent">
                            <v-tooltip>
                                <template v-slot:activator="{ props }">
                                    <v-switch
                                        v-model="invoice.autoValidation"
                                        label="Validation auto"
                                        hide-details
                                        class="mt-0"
                                        v-bind="props"
                                        :readonly="isLocked"
                                    />
                                </template>
                                <span
                                    >Les factures générées seront immédiatement validées (donc non
                                    modifiables !)</span
                                >
                            </v-tooltip>
                        </v-col>
                        <v-col>
                            <v-tooltip>
                                <template v-slot:activator="{ props }">
                                    <v-switch
                                        v-model="invoice.sendEmailAfterValidation"
                                        label="Envoyer un mail"
                                        hide-details
                                        class="mt-0"
                                        v-bind="props"
                                        @click:append="
                                            invoice.sendEmailAfterValidationWithPaymentLink = false
                                        "
                                        :readonly="isLocked"
                                    />
                                </template>
                                <span
                                    >A la validation un email sera envoyé si le "destinataire" est
                                    rempli</span
                                >
                            </v-tooltip>
                        </v-col>
                        <!-- <v-col>
                            <v-tooltip>
                                <template v-slot:activator="{ on, props }">
                                    <v-switch
                                        v-model="invoice.sendEmailAfterValidationWithPaymentLink"
                                        label="Avec lien de paiement"
                                        hide-details
                                        color="primary"
                                        class="mt-0"
                                        inset dense
                                        :disabled="!invoice.sendEmailAfterValidation"
                                        :readonly="isLocked"
                                    ></v-switch>
                                </template>
                                <span></span>
                            </v-tooltip>
                        </v-col> -->
                    </v-row>
                    <!-- <v-divider></v-divider>
                    <v-row no-gutters class="pt-2">
                        <v-col cols="12" class="text--secondary subtitle-1 pb-4">
                            Etiquettes
                        </v-col>
                        <v-col>
                            <v-flex xs12 class="pb-4">
                                <FreeTag
                                    :invoice="invoice"
                                    :companyTags="allCompanyTags"
                                    :multiple="true"
                                    @onTagsChanged="onTagsChanged">
                                </FreeTag>
                            </v-flex>
                        </v-col>
                    </v-row> -->
                </v-card-text>
            </div>
            <div class="bg-white rounded-xl mr-3 py-3 my-2 ml-0" @click="dialogEditCompany = true">
                <v-card-title style="padding-bottom: 5px">
                    <v-row no-gutters>
                        <v-col cols="8" class="text-medium-emphasis text-subtitle-1 pb-4">
                            Détails de votre société
                        </v-col>
                        <v-col
                            cols="4"
                            v-if="invoice.client && invoice.client.id"
                            class="d-flex justify-end"
                        >
                            <v-btn v-if="!isLocked" color="primary" elevation="0" size="small">
                                &#xc9;diter <v-icon size="small" right>$edit</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="4" xs4 class="d-flex justify-end" v-else>
                            <v-btn color="primary" size="small" elevation="0">
                                Sélectionner <v-icon size="small" right>$edit</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="12" primary-title>
                            {{ userCompany.name }}
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text class="pb-1">
                    <v-row no-gutters>
                        <!-- UserCompany -->
                        <v-col cols="12" :class="[userCompany.siret ? '' : 'text-red']">
                            Siret :
                            {{ (userCompany && getSiretValue(userCompany.siret)) || "manquant" }}
                        </v-col>
                        <v-col cols="12" v-if="userCompany">
                            <template
                                v-if="
                                    !userCompany.address ||
                                    !userCompany.postalCode ||
                                    !userCompany.city
                                "
                            >
                                <span class="text-red">Adresse : incomplète</span>
                            </template>
                            <template v-else>
                                Adresse : {{ userCompany.address }} {{ userCompany.postalCode }}
                                {{ userCompany.city }}
                                {{ userCompany.country }}
                            </template>
                        </v-col>
                        <v-col cols="12" v-if="userCompany">
                            <span :class="[userCompany.legalForm ? '' : 'text-red']"
                                >{{ $t("settings.legalForm") }} :
                                {{ userCompany.legalForm || "manquant" }}</span
                            >
                        </v-col>
                        <v-col cols="12" v-if="userCompany">
                            <span :class="[userCompany.registrationTown ? '' : 'text-red']"
                                >Ville enregistement RCS :
                                {{ userCompany.registrationTown || "manquant" }}</span
                            >
                        </v-col>
                    </v-row>
                </v-card-text>
            </div>
            <div class="bg-white rounded-xl py-3 mr-3 my-2 ml-0">
                <v-card-title
                    style="padding-top: 5px; padding-bottom: 5px"
                    @click="openThirdCompanyDialog"
                >
                    <v-row no-gutters>
                        <v-col cols="8" class="text-medium-emphasis text-subtitle-1 pb-4">
                            Détails du client
                        </v-col>
                        <v-col
                            cols="4"
                            v-if="invoice.client && invoice.client.id"
                            class="d-flex justify-end"
                        >
                            <v-btn
                                v-if="!isLocked"
                                color="primary"
                                elevation="0"
                                size="small"
                                :disabled="isDepositOfInvoice"
                            >
                                &#xc9;diter <v-icon size="small" right>$edit</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="4" xs4 class="d-flex justify-end" v-else>
                            <v-btn color="primary" size="small" elevation="0">
                                Sélectionner <v-icon size="small" right>$edit</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="12" primary-title>
                            {{ invoice.client ? invoice.client.name : "" }}
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text class="pb-1">
                    <v-row no-gutters @click="openThirdCompanyDialog">
                        <!-- ThirdPartyCompany -->
                        <oss-dialog
                            v-model="dialogSelectCompany"
                            :title="'Choisir un client'"
                            v-if="dialogSelectCompany"
                            @valid="validCompany"
                            :hide-valid="selectCompanyWindow !== 1"
                            @previous="selectCompanyWindow = 0"
                            :previousDisplay="selectCompanyWindow !== 1"
                        >
                            <v-window v-model="selectCompanyWindow" style="min-width: 60vw">
                                <v-window-item :value="0" :key="0">
                                    <company-table
                                        :showGenericCompany="false"
                                        :showConsumerCompany="true"
                                        :showCustomerCompanies="true"
                                        :showExistingCompanies="false"
                                        :company="invoice.client ? invoice.client.name : ''"
                                        :siret="invoice.client ? invoice.client.siret : ''"
                                        :siren="invoice.client ? invoice.client.siren : ''"
                                        :vatNumber="invoice.client ? invoice.client.vatNumber : ''"
                                        :parentCompanyId="selectedCompany.id"
                                        @select-company="companyToEdit"
                                    />
                                </v-window-item>
                                <v-window-item :value="1" :key="1">
                                    <editCompany
                                        ref="editCompany"
                                        :in-company="invoice.client"
                                        :clientInvoiceMode="true"
                                        @updated="companySelected($event)"
                                    />
                                </v-window-item>
                            </v-window>
                        </oss-dialog>
                        <v-col cols="12" v-if="invoice.client.type !== 'CONSUMER'">
                            <template v-if="invoice.client.siret">
                                Siret : {{ invoice.client && getSiretValue(invoice.client.siret) }}
                            </template>
                            <template v-else-if="invoice.client.vatNumber">
                                Numero de TVA : {{ invoice.client.vatNumber }}
                            </template>
                            <template v-else> Siret : Pas d'information </template>
                        </v-col>
                        <v-col
                            cols="12"
                            v-if="invoice.client && invoice.client.type !== 'CONSUMER'"
                        >
                            Adresse : {{ invoice.client.address }} {{ invoice.client.postalCode }}
                            {{ invoice.client.city }}
                            {{ invoice.client.country }}
                        </v-col>
                        <v-col
                            cols="12"
                            v-if="invoice.client && invoice.client.isActive === false"
                            class="text-red"
                        >
                            Attention : Etablissement fermé !
                        </v-col>
                        <v-col cols="12" v-if="thirdPartyCompanyTags.length">
                            <v-chip
                                label
                                :ripple="false"
                                v-for="(tpcTag, index) of thirdPartyCompanyTags"
                                :key="index"
                                class="text mr-1"
                                size="x-small"
                            >
                                <span :style="'color:' + labelTextColor + ';'">{{
                                    tpcTag.tag.name
                                }}</span>
                            </v-chip>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider class="ma-4" />
                <v-card-title class="pt-0 pb-1 text-medium-emphasis text-subtitle-1">
                    <v-row no-gutters>
                        <v-col cols="8" class="text-medium-emphasis text-subtitle-1 pb-4">
                            Destinataire
                        </v-col>
                        <v-col
                            cols="4"
                            v-if="invoice.client && invoice.client.id"
                            class="d-flex justify-end"
                        >
                            <div>
                                <v-btn
                                    elevation="0"
                                    size="small"
                                    color="primary"
                                    @click="invoiceThirdCompanyUsersDialog = true"
                                    data-cy="InvoiceEdition-editer"
                                >
                                    &#xc9;diter
                                    <v-icon right>$edit</v-icon>
                                </v-btn>
                                <InvoiceThirdCompanyUsersDialog
                                    v-model="invoiceThirdCompanyUsersDialog"
                                    v-if="invoiceThirdCompanyUsersDialog"
                                    :companyId="companyId"
                                    :thirdPartyCompanyId="invoice.client.id"
                                    :onlyToCreate="false"
                                    @valid="setReceiverUser($event)"
                                >
                                </InvoiceThirdCompanyUsersDialog>
                            </div>
                        </v-col>
                        <!-- <v-col cols="4" xs4 class="d-flex justify-end" v-else>
                            <v-btn color="primary" dark size="small" elevation="0" rounded>
                                Sélectionner <v-icon  size="small" right>$edit</v-icon>
                            </v-btn>
                        </v-col> -->
                    </v-row>
                </v-card-title>
                <v-card-text class="py-1">
                    <v-row
                        no-gutters
                        v-for="(receiver, index) of invoice.data.receivers"
                        :key="index"
                    >
                        <v-col cols="6" class="pr-1 pb-2">
                            <v-text-field-filled
                                v-model="receiver.firstname"
                                label="Prénom"
                                hide-details
                                readonly
                                density="compact"
                            />
                        </v-col>
                        <v-col cols="6" class="pl-1 pb-2">
                            <v-text-field-filled
                                v-model="receiver.lastname"
                                label="Nom"
                                hide-details
                                readonly
                                density="compact"
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-form v-model="isEmailValid">
                                <v-text-field-filled
                                    v-model="receiver.email"
                                    label="Adresse mail"
                                    :rules="[rules.isEmail]"
                                    readonly
                                    density="compact"
                                />
                            </v-form>
                        </v-col>
                        <!-- <v-col cols="12" class="d-flex align-center justify-end" v-if="invoice.status === 'VALIDATED'">
                            <v-btn
                                rounded
                                 size="small"
                                color="primary"

                                elevation="0"
                                v-if="invoice.status === 'VALIDATED'"
                                :disabled="!isEmailValid || !invoice.receiverEmail"
                                @click="updateReceiverEmail()"
                            >
                                Modifier
                            </v-btn>
                        </v-col> -->
                    </v-row>
                </v-card-text>
            </div>
            <div class="default_card ml-0" v-if="invoice.deposits && invoice.deposits.length">
                <v-card-title style="padding-bottom: 5px">
                    <v-row no-gutters>
                        <v-col cols="12" class="text--secondary subtitle-1 pb-2"> Acomptes </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text class="pb-1">
                    <v-row
                        no-gutters
                        v-for="(deposit, index) in invoice.deposits"
                        :key="index"
                        class="d-flex align-center mb-2"
                    >
                        <v-col
                            cols="3"
                            class="text--primary"
                            style="
                                overflow: hidden;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 1;
                            "
                        >
                            {{ formatDate(deposit.date) }}
                        </v-col>
                        <v-col
                            cols="6"
                            class="text--primary"
                            style="
                                overflow: hidden;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 1;
                            "
                        >
                            {{ deposit.title }}
                        </v-col>
                        <v-col cols="2" class="text--primary">
                            {{ newCommonFormatCurrency(deposit.grossAmount, undefined) }}
                        </v-col>
                        <v-col cols="1" class="text--primary">
                            <v-btn-icon
                                icon="$oss-eye"
                                class="btn"
                                :color="'primary'"
                                @click.stop="
                                    $router.push({
                                        name: 'invoiceEdition',
                                        params: { companyId, id: deposit.id },
                                    })
                                "
                                size="small"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
            </div>
            <div class="default_card ml-0" v-else-if="invoice.depositOf">
                <v-card-title style="padding-bottom: 5px">
                    <v-row no-gutters>
                        <v-col cols="12" class="text--secondary subtitle-1 pb-2">
                            Devis de référence
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text class="pb-1">
                    <v-list>
                        <v-list-item
                            @click.stop="
                                $router.push({
                                    name: 'invoiceEdition',
                                    params: { companyId, id: invoice.depositOf.id },
                                })
                            "
                        >
                            <v-row no-gutters class="d-flex align-center">
                                <v-col
                                    cols="3"
                                    class="text--primary"
                                    style="
                                        overflow: hidden;
                                        display: -webkit-box;
                                        -webkit-box-orient: vertical;
                                        -webkit-line-clamp: 1;
                                    "
                                >
                                    {{ formatDate(invoice.depositOf.date) }}
                                </v-col>
                                <v-col
                                    cols="6"
                                    class="text--primary"
                                    style="
                                        overflow: hidden;
                                        display: -webkit-box;
                                        -webkit-box-orient: vertical;
                                        -webkit-line-clamp: 1;
                                    "
                                >
                                    {{ invoice.depositOf.title }}
                                </v-col>
                                <v-col cols="2" class="text--primary">
                                    {{
                                        newCommonFormatCurrency(
                                            invoice.depositOf.grossAmount,
                                            undefined,
                                        )
                                    }}
                                </v-col>
                                <v-col cols="1" class="text--primary d-flex justify-end">
                                    <v-icon icon="$oss-chevron-right"></v-icon>
                                </v-col>
                                <!-- <v-col cols="1" class="text--primary">
                                    <v-btn-icon
                                        icon="$oss-eye"
                                        variant="flat"
                                        :color="'secondary'"
                                        @click.stop="
                                            $router.push({
                                                name: 'invoiceEdition',
                                                params: { companyId, id: invoice.depositOf.id },
                                            })
                                        "
                                        size="small"
                                    />
                                </v-col> -->
                            </v-row>
                        </v-list-item>
                        <v-list-item
                            v-for="(depositOfDeposit, index) in invoice.depositOf.deposits"
                            :key="index"
                            @click.stop="
                                $router.push({
                                    name: 'invoiceEdition',
                                    params: { companyId, id: depositOfDeposit.id },
                                })
                            "
                        >
                            <v-row no-gutters class="d-flex align-center">
                                <v-col
                                    cols="3"
                                    class="text--primary"
                                    style="font-size: 80%; font-style: italic"
                                >
                                    <!-- {{formatDate(depositOfDeposit.date)}} -->
                                </v-col>
                                <v-col
                                    cols="6"
                                    class="text--primary"
                                    style="font-size: 80%; font-style: italic"
                                >
                                    {{ depositOfDeposit.title }}
                                </v-col>
                                <v-col cols="2" class="text--primary">
                                    {{
                                        getPercentageOfDeposit(depositOfDeposit)
                                            ? getPercentageOfDeposit(depositOfDeposit) + "%"
                                            : ""
                                    }}
                                </v-col>
                                <v-col cols="1" class="text--primary d-flex justify-end">
                                    <v-icon icon="$oss-chevron-right"></v-icon>
                                </v-col>
                            </v-row>
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </div>
            <div class="default_card ml-0" v-else-if="invoice.creditNoteOf">
                <v-card-title style="padding-bottom: 5px">
                    <v-row no-gutters>
                        <v-col cols="12" class="text-medium-emphasis text-subtitle-1 pb-2">
                            Avoir de la facture
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text class="pb-1">
                    <v-row no-gutters class="d-flex align-center">
                        <v-col
                            cols="3"
                            class="text--primary"
                            style="
                                overflow: hidden;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 1;
                            "
                        >
                            {{ formatDate(invoice.creditNoteOf.date) }}
                        </v-col>
                        <v-col
                            cols="6"
                            class="text--primary"
                            style="
                                overflow: hidden;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 1;
                            "
                        >
                            {{ invoice.creditNoteOf.title }}
                        </v-col>
                        <v-col cols="2" class="text--primary">
                            {{
                                newCommonFormatCurrency(invoice.creditNoteOf.grossAmount, undefined)
                            }}
                        </v-col>
                        <v-col cols="1" class="text--primary">
                            <v-btn-icon
                                icon="$oss-eye"
                                class="btn ml-1"
                                :color="'primary'"
                                @click.stop="
                                    $router.push({
                                        name: 'invoiceEdition',
                                        params: { companyId, id: invoice.creditNoteOf.id },
                                    })
                                "
                                size="small"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
            </div>
            <div
                class="default_card ml-0"
                v-else-if="invoice.creditNotes && invoice.creditNotes.length"
            >
                <v-card-title style="padding-bottom: 5px">
                    <v-row no-gutters>
                        <v-col cols="12" class="text--secondary subtitle-1 pb-2">
                            {{ invoice.creditNotes.length > 1 ? "Avoirs" : "Avoir" }}
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text class="pb-1">
                    <v-row
                        no-gutters
                        v-for="(creditNote, index) in invoice.creditNotes"
                        :key="index"
                        class="d-flex align-center mb-2"
                    >
                        <v-col
                            cols="3"
                            class="text--primary"
                            style="
                                overflow: hidden;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 1;
                            "
                        >
                            {{ formatDate(creditNote.date) }}
                        </v-col>
                        <v-col
                            cols="6"
                            class="text--primary"
                            style="
                                overflow: hidden;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 1;
                            "
                        >
                            {{ creditNote.title }}
                        </v-col>
                        <v-col cols="2" class="text--primary">
                            {{ newCommonFormatCurrency(creditNote.grossAmount, undefined) }}
                        </v-col>
                        <v-col cols="1" class="text--primary">
                            <v-btn-icon
                                icon="$oss-eye"
                                class="btn ml-1"
                                :color="'primary'"
                                @click.stop="
                                    $router.push({
                                        name: 'invoiceEdition',
                                        params: { companyId, id: creditNote.id },
                                    })
                                "
                                size="small"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
            </div>
            <div class="default_card ml-0 my-0" v-if="invoice.replacementOf">
                <v-card-title style="padding-bottom: 5px">
                    <v-row no-gutters>
                        <v-col cols="12" class="text--secondary subtitle-1 pb-2">
                            Remplace la facture
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text class="pb-1">
                    <v-row no-gutters class="d-flex align-center">
                        <v-col
                            cols="3"
                            class="text--primary"
                            style="
                                overflow: hidden;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 1;
                            "
                        >
                            {{ formatDate(invoice.replacementOf.date) }}
                        </v-col>
                        <v-col
                            cols="6"
                            class="text--primary"
                            style="
                                overflow: hidden;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 1;
                            "
                        >
                            {{ invoice.replacementOf.title }}
                        </v-col>
                        <v-col cols="2" class="text--primary">
                            {{
                                newCommonFormatCurrency(
                                    invoice.replacementOf.grossAmount,
                                    undefined,
                                )
                            }}
                        </v-col>
                        <v-col cols="1" class="text--primary">
                            <v-btn-icon
                                icon="$oss-eye"
                                class="btn ml-1"
                                :color="'primary'"
                                @click.stop="
                                    $router.push({
                                        name: 'invoiceEdition',
                                        params: { companyId, id: invoice.replacementOf.id },
                                    })
                                "
                                size="small"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
            </div>
            <div class="default_card ml-0 my-0" v-if="invoice.replacedBy">
                <v-card-title style="padding-bottom: 5px">
                    <v-row no-gutters>
                        <v-col cols="12" class="text--secondary subtitle-1 pb-2">
                            Est remplacée par la facture
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text class="pb-1">
                    <v-row no-gutters class="d-flex align-center">
                        <v-col
                            cols="3"
                            class="text--primary"
                            style="
                                overflow: hidden;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 1;
                            "
                        >
                            {{ formatDate(invoice.replacedBy.date) }}
                        </v-col>
                        <v-col
                            cols="6"
                            class="text--primary"
                            style="
                                overflow: hidden;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 1;
                            "
                        >
                            {{ invoice.replacedBy.title }}
                        </v-col>
                        <v-col cols="2" class="text--primary">
                            {{ newCommonFormatCurrency(invoice.replacedBy.grossAmount, undefined) }}
                        </v-col>
                        <v-col cols="1" class="text--primary">
                            <v-btn-icon
                                icon="$oss-eye"
                                class="btn ml-1"
                                :color="'primary'"
                                @click.stop="
                                    $router.push({
                                        name: 'invoiceEdition',
                                        params: { companyId, id: invoice.replacedBy.id },
                                    })
                                "
                                size="small"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
            </div>
            <div class="mt-auto pa-4 d-flex justify-end">
                <div class="d-flex mr-4">
                    <v-btn-prev :disabled="prevDisabled" @click="prev()" />
                    <v-btn-next :disabled="nextDisabled" @click="next()" />
                </div>
                <v-btn
                    class="elevation-0"
                    @click="saveInvoice()"
                    :loading="isSaving"
                    :disabled="disabledSave"
                    v-if="!isLocked"
                    size="small"
                >
                    Enregistrer
                </v-btn>
            </div>
        </v-col>
        <oss-dialog
            v-model="dialogEditCompany"
            :actions="editCompanyActions"
            title="Modifier les informations de votre société"
        >
            <editCompany
                ref="editCompany"
                :companyId="userCompany.id"
                :hideUpsertBtn="true"
                :actions="editCompanyActions"
                @updated="closeDialogEditCompany"
            />

            <template v-slot:actions>
                <!-- <v-btn
                    class="rounded-lg gradient"
                    :disabled="disabledModification()"
                    rounded
                     size="small"
                    block
                     size=“x-large”
                    elevation="0"

                    @click="emitModifyCompany()"
                >
                    {{ userCompany.id ? "Modifier" : "Créer" }}
                </v-btn> -->
            </template>
        </oss-dialog>
        <oss-dialog v-model="errorDateDialog" title="Problème de date">
            <v-card-text>
                <v-row no-gutters>
                    <v-col cols="12" class="body-1">
                        La date de facturation ne peut pas être antérieur a la date de facturation
                        de la dernière facture validée (La dernière facturation date du
                        {{ lastDateInvoice ? formatDate(lastDateInvoice) : "" }}).
                    </v-col>
                </v-row>
            </v-card-text>
        </oss-dialog>
        <oss-dialog v-model="dialogCreditNote" title="Créer un avoir" width="550px">
            Voulez vous créer un avoir pour cette facture ?
            <template v-slot:actions>
                <v-btn-primary
                    block
                    @click="
                        dialogCreditNote = false;
                        createCreditNote();
                    "
                    data-cy="InvoiceEdition-yes"
                    size="large"
                >
                    Oui
                </v-btn-primary>
            </template>
        </oss-dialog>
        <oss-dialog
            v-model="dialogConfirmDuplicate"
            title="Dupliquer le document"
            :validTitle="'Dupliquer'"
            @valid="saveInvoice(true)"
            prefixDataCy="InvoiceEdition-dupliquer"
        >
            <div :style="{ width: $vuetify.display.smAndDown ? '80vw' : '30vw' }">
                Voulez-vous vraiment dupliquer ce document ?
            </div>
            <!-- <template v-slot:actions>
                <v-btn
                    color="secondary"
                    block
                    elevation="0"
                    large
                    class="rounded-lg gradient"
                    @click="saveInvoice(true);"
                >
                    Dupliquer
                </v-btn>
            </template> -->
        </oss-dialog>

        <oss-dialog
            v-if="!isNewInvoice && invoice && invoice.status === 'DRAFT'"
            v-model="dialogDeleteDocument"
            title="Supprimer la facture"
            @valid="deleteDocument"
            :validLoading="deleteLoading"
        >
            <div :style="{ width: $vuetify.display.smAndDown ? '80vw' : '30vw' }">
                <h4 class="text-center">
                    &#xca;tes-vous sûr(e) de vouloir supprimer ce brouillon ? (action irréversible)
                </h4>
            </div>
        </oss-dialog>

        <oss-dialog
            v-model="reccurencyDialog"
            title="Récurrence"
            width="40vw"
            validTitle="Je ne suis pas censé exister"
            validDisabled
            :hideValid="true"
        >
            <v-window v-model="wizardStep" touchless style="min-height: 27vh">
                <v-window-item :value="0">
                    Date de la première facture
                    <v-date-picker-wrapper
                        v-model="invoice.startDate"
                        full-width
                        :landscape="!$vuetify.display.mobile"
                        class="elevation-0"
                        color="gradient"
                        scrollable
                    />
                </v-window-item>
                <v-window-item :value="1">
                    <v-col cols="12">
                        Date de la dernière facture
                        <v-date-picker-wrapper
                            v-model="invoice.endDate"
                            full-width
                            :landscape="!$vuetify.display.mobile"
                            class="elevation-0"
                            color="gradient"
                            scrollable
                            :disabled="isInfinitReccurency"
                        />
                    </v-col>
                    <v-col cols="12">
                        <v-switch
                            v-model="isInfinitReccurency"
                            class="ma-2"
                            label="Sans date de fin"
                        />
                    </v-col>
                </v-window-item>
                <v-window-item :value="2">
                    <v-row>
                        <v-col cols="12">
                            <v-list-item
                                v-for="recType in reccurencyType"
                                :key="recType.value"
                                @click="
                                    () => {
                                        invoice.periodicity = recType.value;
                                    }
                                "
                                style="background: #fff"
                                class="mt-2 oss-list-item"
                            >
                                <template v-slot:append class="my-0">
                                    <v-btn-icon
                                        color="primary"
                                        :icon="
                                            invoice.periodicity === recType.value
                                                ? '$radio_button_checked'
                                                : '$radio_button_unchecked'
                                        "
                                    >
                                    </v-btn-icon>
                                </template>
                                <v-list-item-title>
                                    {{ recType.text }}
                                </v-list-item-title></v-list-item
                            >
                        </v-col>
                    </v-row>
                </v-window-item>
                <v-window-item :value="3">
                    <v-row no-gutters>
                        <v-col cols="12">
                            <oss-text-field-filled
                                outlined
                                v-model="dueDateAmount"
                                label="Nombre"
                                dense
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-list-item
                                v-for="unit in unitsOfTime"
                                :key="unit.value"
                                @click="unitOfTime = unit.value"
                                style="background: #fff"
                                class="mt-2 oss-list-item"
                            >
                                <template v-slot:append class="my-0">
                                    <v-btn-icon
                                        color="primary"
                                        :icon="
                                            unitOfTime === unit.value
                                                ? '$radio_button_checked'
                                                : '$radio_button_unchecked'
                                        "
                                    >
                                    </v-btn-icon>
                                </template>
                                <v-list-item-title>
                                    {{ unit.text }}
                                </v-list-item-title></v-list-item
                            >
                        </v-col>
                    </v-row>
                </v-window-item>
            </v-window>
            <v-row no-gutters pt-2>
                <v-col cols="6">
                    <v-btn
                        :disabled="wizardStep === 0"
                        rounded
                        elevation="0"
                        @click="wizardStep--"
                        size="small"
                    >
                        Précédent
                    </v-btn>
                </v-col>
                <v-col cols="6" class="d-flex justify-end" v-if="wizardStep !== 3">
                    <v-btn elevation="0" @click="wizardStep++" size="small"> Suivant </v-btn>
                </v-col>
                <v-col cols="6" class="d-flex justify-end" v-else>
                    <v-btn
                        elevation="0"
                        @click="
                            reccurencyDialog = false;
                            wizardStep = 0;
                        "
                        data-cy="InvoiceEdition-valider"
                        size="small"
                    >
                        Valider
                    </v-btn>
                </v-col>
            </v-row>
        </oss-dialog>

        <oss-dialog
            v-model="cancelAndReplaceDialog"
            title="Annuler et remplacer"
            :validLoading="isSaving"
            @valid="cancelAndReplaceInvoice()"
        >
            <v-card
                elevation="0"
                class="px-4 my-4"
                style="background-color: white; border-radius: 25px"
            >
                <v-card-text class="text-h6 mx-auto">
                    <div>Cliquer sur VALIDER va :</div>
                    <div class="pl-4">
                        - Créer un avoir opposé à cette facture, et les lettrer ensemble
                    </div>
                    <div class="pl-4">
                        - Créer une nouvelle facture (semblable à celle-ci mais encore modifiable)
                        et vous rediriger dessus
                    </div>
                </v-card-text>
            </v-card>
        </oss-dialog>

        <oss-dialog
            title="Convertir"
            v-model="convertDocumentDialog"
            :hideValid="!convertStep"
            :validDisabled="!depositIsValid"
            :validLoading="generateDepositloading"
            :previous-display="!!convertStep"
            @previous="convertStep--"
            @valid="generateDeposits()"
        >
            <v-window v-model="convertStep">
                <v-window-item :value="0" :key="0">
                    <v-list two-lines>
                        <v-list-item
                            @click="saveInvoice(true, 'INVOICE')"
                            v-if="isQuote || isBillOfDelivery"
                            class="mb-2 py-1"
                            data-cy="InvoiceEdition-quoteInvoice"
                        >
                            <v-list-item-title>Convertir en facture</v-list-item-title>
                            <template v-slot:append>
                                <v-icon size="small">$oss-chevron-right</v-icon>
                            </template>
                        </v-list-item>
                        <v-list-item
                            @click="convertStep = 1"
                            v-if="isQuote || isBillOfDelivery"
                            :disabled="invoice.status === 'DRAFT'"
                            class="mb-2 py-1"
                            data-cy="InvoiceEdition-quoteInvoiceWithDeposit"
                        >
                            <v-list-item-title
                                >Convertir en facture avec acomptes</v-list-item-title
                            >
                            <template v-slot:append>
                                <v-icon size="small">$oss-chevron-right</v-icon>
                            </template>
                        </v-list-item>
                        <v-list-item
                            @click="saveInvoice(true, 'BILL_DELIVERY')"
                            v-if="isQuote"
                            class="mt-2 py-1"
                            data-cy="InvoiceEdition-quoteDeliveryNote"
                        >
                            <v-list-item-title>Convertir en bon de livraison</v-list-item-title>
                            <template v-slot:append>
                                <v-icon size="small">$oss-chevron-right</v-icon>
                            </template>
                        </v-list-item>
                    </v-list>
                </v-window-item>
                <v-window-item :value="1" :key="1">
                    <CreateDeposit
                        v-model="depositIsValid"
                        :invoice="invoice"
                        :grossAmountTotal="grossAmountTotal"
                        @newDeposits-updated="newDeposits = $event"
                    />
                    <!-- <CreateDeposit
                        v-model="depositIsValid"
                        :invoice="invoice"
                        :grossAmountTotal="grossAmountTotal"
                        @newDeposits-updated="newDeposits = $event"
                        @isValid-updated="depositIsValid = $event"
                    /> -->
                </v-window-item>
            </v-window>
        </oss-dialog>
        <oss-dialog
            title="Confirmation"
            v-model="dialogConfirmInvoice"
            @valid="confirmInvoiceStepAction()"
            @previous="confirmInvoicePreviousStepAction()"
            :previous-display="confirmInvoiceStep != confirmInvoiceInitialStep ? true : false"
            prefixDataCy="InvoiceEdition-valid"
            :loading="isSaving"
            :validDisabled="isSaving"
        >
            <InvoiceConfirmInvoice
                :step="confirmInvoiceStep"
                :data="confirmInvoiceData"
                :type="invoiceConfirmInvType"
                :otherChrono="otherChrono"
            />
        </oss-dialog>
        <oss-dialog v-model="dialogPayment" :actions="payActions" @close="dialogPayment = false">
            <Pay
                :withoutCredits="true"
                :fromPaymentManagementToGenerateEmail="true"
                :companyId="companyId"
                :thirdPartyCompanyId="invoice.client.id"
                accountableAccountName="411"
                :accountingLines="accountingLines"
                :actions="payActions"
                @getBudgetInsightOptions="mailerDialogWithBudgetInsight"
            >
            </Pay>
        </oss-dialog>
    </v-row>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";

import { InvoiceEditionBase } from "./InvoiceEditionBase";

import ProductsList from "./SelectInvoiceProduct.vue";
import MailerDialog from "../mail/MailerDialog.vue";
import InvoiceProductsDialog from "./InvoiceProductsDialog.vue";
import InvoiceThirdCompanyUsersDialog from "./InvoiceThirdCompanyUsersDialog.vue";
import InvoiceMatrix from "./InvoiceMatrix.vue";
import FreeTag from "../tag/FreeTag.vue";
import CreateDeposit from "./CreateDeposit.vue";
import TutorialButtonDialog from "../tutorial/TutorialButtonDialog.vue";

import { emailPattern } from "../../../../backend/src/common/mail/mailerServices";

import UPDATE_INVOICE_RECEIVERS from "../../graphql/invoice/UpdateInvoiceReceiver.gql";
import THIRDPARTYCOMPANY_TAGS_QUERY from "../../graphql/tag/ThirdPartyCompanyTags.gql";
import INVOICE_SIGNATURE from "../../graphql/invoice/InvoiceSignature.gql";
import GET_PREV_NEXT_INVOICE from "../../graphql/invoice/GetPrevNextInvoice.gql";
import GET_INVOICE_THEME_BACKGROUND from "@/graphql/invoiceTheme/GetInvoiceThemeBackground.gql";
import GET_INVOICE_ADDITIONAL_DOCUMENT from "@/graphql/invoiceTheme/GetInvoiceThemeAdditionalDocument.gql";
import GET_DEFAULT_MAILER from "@/graphql/company/GetDefaultInvoiceMailer.gql";
import GET_PAYMENT_INFO from "@/graphql/document/GetAccountingLines.gql";

import { getSiretValue } from "../../services/companyServices";
import { getCommonInvoiceWhere } from "@/services/graphqlServices";
import colors from "vuetify/util/colors";
import draggable from "vuedraggable";

import getEnv from "../../env";
import { DialogAction } from "@/services/dialogAction";
import InvoiceHtmlViewService from "../../../../backend/src/common/invoiceTheme/InvoiceHtmlBuilder";
const env = getEnv();

import InvoiceThemeService from "../../../../backend/src/common/invoiceTheme/invoiceThemeService";
import INVOICE_THEMES from "@/graphql/invoiceTheme/InvoiceThemes.gql";
import InvoiceHtmlTemplateView from "@/views/invoiceTheme/InvoiceHtmlTemplateView.vue";
import InvoiceConfirmInvoice from "./InvoiceConfirmInvoice.vue";
import Pay from "@/views/pay/Pay.vue";

// import { jsPDF } from "jspdf"
import InvoiceThemeFrontService from "@/services/invoiceThemeFrontServices";
import DeliveryNoteHtmlBuilder from "../../../../backend/src/common/invoiceTheme/DeliveryNoteHtmlBuilder";
import { Component, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import moment from "moment-timezone";

@Component({
    components: {
        // CreateInvoiceProduct,
        ProductsList,
        MailerDialog,
        InvoiceProductsDialog,
        InvoiceThirdCompanyUsersDialog,
        InvoiceMatrix,
        FreeTag,
        draggable,
        CreateDeposit,
        TutorialButtonDialog,
        // SelectUser,
        InvoiceHtmlTemplateView,
        InvoiceConfirmInvoice,
        Pay,
    },
})
export class InvoiceEdition extends InvoiceEditionBase {
    dialogProductsList = false;
    dialogProductsCreation = false;
    dialogPayment = false;
    wizardStep = 0;

    convertStep = 0;

    selectCompanyWindow = 0;

    mailerDialog = false;
    isEmailValid = false;
    invoiceThirdCompanyUsersDialog = false;

    localEnv = env.environnement;

    expandKey = 0;

    previewScaleSize = 1;

    invoiceDefaultMailerInfos: any;

    invoicePaymentInfos: any;

    accountingLines: any = {};

    budgetInsightOptions: any = {};

    editCompanyActions = {
        action: new DialogAction(),
    };

    payActions = {
        action: new DialogAction(),
    };

    get enablePayment() {
        if (this.invoice.type !== "INVOICE") {
            return false;
        }
        return true;
    }

    async showPayDialog() {
        // console.log(this.invoice);
        const result = await this.$apollo.query({
            query: GET_PAYMENT_INFO,
            variables: {
                documentId: this.invoice.document.id,
            },
        });
        this.accountingLines = result.data.document.accountingLines;
        this.dialogPayment = true;
    }

    mailerDialogWithBudgetInsight(value_from_child) {
        this.budgetInsightOptions = value_from_child;
        this.budgetInsightOptions.isPaymentLink = true;
        this.getDefaultMailer();
    }

    getDefaultMailerWithSignature() {
        this.budgetInsightOptions = { isSignature: true };
        this.getDefaultMailer();
    }

    async getDefaultMailer() {
        const result = await this.$apollo.query({
            query: GET_DEFAULT_MAILER,
            fetchPolicy: "network-only",
            variables: {
                invoiceId: this.invoice.id,
            },
        });
        this.invoiceDefaultMailerInfos = result.data.getDefaultInvoiceMailer;
        this.mailerDialog = true;
        this.dialogPayment = false;
    }

    confirmInvoiceStepAction() {
        switch (this.confirmInvoiceStep) {
            case 0:
                this.confirmInvoiceStep = 1;
                break;
            case 1:
                this.confirmInvoiceStep = 2;
                break;
            case 2:
                if (!this.confirmInvoiceData.isError) {
                    this.confirmInvoiceStep = 3;
                }
                break;
            case 3:
                if (!this.confirmInvoiceData.isError) {
                    this.confirmInvoiceStep = 4;
                }
                break;
            case 4:
                if (!this.confirmInvoiceData.isError) {
                    this.confirmInvoice();
                    this.dialogConfirmInvoice = false;
                }
                break;
        }
    }

    confirmInvoicePreviousStepAction() {
        switch (this.confirmInvoiceStep) {
            case 2:
                this.confirmInvoiceStep = 1;
                break;
            case 3:
                if (!this.confirmInvoiceData.isError) {
                    this.confirmInvoiceStep = 2;
                }
                break;
            case 4:
                if (!this.confirmInvoiceData.isError) {
                    this.confirmInvoiceStep = 3;
                }
                break;
        }
    }

    get disabledSave() {
        if (!this.isEmailValid) return true;
        if (!this.invoice?.client?.id) return true;
        if (this.depositSwitch && !this.depositIsValid) return true;
        return false;
    }

    get otherChrono() {
        return this.invoiceData?.chrono || undefined;
    }

    get rules() {
        return {
            notEmpty: (value) => {
                if (!value) {
                    return "A remplir";
                }
                return true;
            },
            isEmail: (value) => {
                if (!value) {
                    return true;
                }
                const test =
                    emailPattern.test(value) || value === "" || value == null ? true : false;
                return test || "E-mail invalide";
            },
            isPercentage: (value) => {
                if (!value) return true;
                // if (!checkFloat(value)) return "Montant invalide"
                if (parseFloat(value) >= 0 && parseFloat(value) <= 100) {
                    return true;
                }
                return "Pourcentage invalide";
            },
            isCorrectAmount: (value) => {
                if (!value) return true;
                // if (!checkFloat(value)) return "Montant invalide"
                if (parseFloat(value) > 0 && parseFloat(value) <= this.grossAmountTotal) {
                    return true;
                }
                if (parseFloat(value) > this.grossAmountTotal) {
                    return "Ne peut pas dépasser le total de la facture";
                }
                return "Montant invalide";
            },
            // isAmountOrPercentage: (value) => {
            //     if(!value) {
            //         return true
            //     }
            //     if(this.discountLinesType === "%") {
            //         if(parseInt(value) && parseInt(value) >= 0 && parseInt(value) <= 100) {
            //             return true
            //         } else { return "Pourcentage invalide" }
            //     } else {
            //         if(parseInt(value) && parseInt(value) >= 0 && parseInt(value) <= this.grossAmountTotal) {
            //             return true
            //         } else if(parseInt(value) > this.grossAmountTotal) {
            //             return "Ne peut pas dépasser le total de la facture"
            //         } else { return "Montant invalide" }
            //     }

            // }
        };
    }

    // get invoiceDefaultMailerInfos() {
    // return invoiceDefaultMailer(this.invoice, this.currentUser, this.selectedCompany);
    // }

    async setReceiverUser(selectedUser) {
        this.invoice.data.receivers = [{ ...selectedUser }];

        if (this.invoice.status !== "DRAFT") {
            await this.updateReceivers();
        }

        this.invoiceThirdCompanyUsersDialog = false;
    }

    // @Watch('invoice.receiverEmail')
    async updateReceivers() {
        if (this.invoice?.id) {
            await this.$apollo.mutate({
                mutation: UPDATE_INVOICE_RECEIVERS,
                variables: {
                    id: this.invoice.id,
                    invoiceReceivers: this.invoice.data.receivers,
                },
            });
        }
    }

    beforeMount() {
        this.updatePreviewScaleSize();
        this.onMounted();
        window.addEventListener("resize", this.updatePreviewScaleSize);
    }

    beforeDestroy() {
        window.removeEventListener("resize", this.updatePreviewScaleSize);
    }

    getComponentWidth(compRef) {
        if (compRef) {
            return compRef.offsetWidth;
        }
        return null;
    }

    updatePreviewScaleSize() {
        const ratioNormalizer = 1.3; // Determined by trial and error
        const mainContainerWidth = this.getComponentWidth(this.$refs.mainContainer);
        const previewContainerWidth = this.getComponentWidth(this.$refs.previewContainer);
        if (mainContainerWidth && previewContainerWidth) {
            this.previewScaleSize = Math.min(
                (previewContainerWidth / mainContainerWidth) * ratioNormalizer,
                1,
            );
        } else {
            this.previewScaleSize = Math.min(0.6 * ratioNormalizer, 1);
        }
    }

    @Apollo({
        query() {
            return THIRDPARTYCOMPANY_TAGS_QUERY;
        },
        variables() {
            return {
                companyId: this.companyId,
                thirdPartyCompanyIds: [this.invoice?.client?.id],
            };
        },
        skip() {
            return !this.invoice?.client?.id || !this.companyId;
        },
        specificResult({ data, loading }) {
            this.loading = loading;
            if (!loading && data && data.thirdPartyCompanyTags) {
                this.thirdPartyCompanyTags = data.thirdPartyCompanyTags;
            } else {
                this.thirdPartyCompanyTags = [];
            }
        },
    })
    thirdPartyCompanyTags = [];

    disabledModification() {
        if (this.$refs && this.$refs.editCompany) {
            return this.$refs.editCompany.disabledModification_();
        }
        return true;
    }

    emitModifyCompany() {
        this.$refs.editCompany.upsertCompany();
    }

    openThirdCompanyDialog() {
        if (!this.isLocked && !this.isDepositOfInvoice) {
            this.dialogSelectCompany = true;
        }
    }

    async askForSignature() {
        await this.$apollo.mutate({
            mutation: INVOICE_SIGNATURE,
            variables: {
                invoiceId: this.invoice.id,
                title: this.invoice.title || this.invoice.number,
                receivers: this.invoice.data.receivers,
            },
        });
    }

    updateClientInvoice(data) {
        this.invoice.client = data;
        this.dialogSelectCompany = false;
    }

    async companyToEdit(company) {
        await this.companySelected(company);
        if (company.type === "CONSUMER") {
            this.dialogSelectCompany = false;
            return;
        }
        this.selectCompanyWindow = 1;
    }

    async companyToSet(company) {
        await this.companySelected(company);
        this.selectCompanyWindow = 0;
        this.dialogSelectCompany = false;
    }

    async validCompany() {
        await this.$refs.editCompany.upsertCompany();
        this.dialogSelectCompany = false;
    }

    get enableSendMail() {
        return (
            this.invoice &&
            !this.isNewInvoice &&
            !this.isRecurrent &&
            (this.invoice.status === "VALIDATED" || this.invoice.status === "ACCEPTED") &&
            this.invoice.document
        );
    }

    getSiretValue(siret: string) {
        return getSiretValue(siret);
    }

    get labelTextColor() {
        return colors.grey.darken2;
    }

    async onTagsChanged(data) {
        this.tags = data.tags;
    }

    get allowToCreateACreditNote() {
        if (!this.isNewInvoice && this.isInvoice && this.invoice?.status === "VALIDATED") {
            if (!(this.invoice as any)?.replacedBy?.id) {
                return true;
            }
        }
        return false;
    }

    get unitPriceLabel() {
        if (this.displayTTCAmounts) {
            return "Prix unitaire (TTC)";
        }
        return "Prix unitaire";
    }

    resetOtherDiscountType(line = undefined) {
        const elementToChange = line ? line : this.invoice;
        if (elementToChange.discountType === "€" || (!line && this.globalDiscountType === "€")) {
            elementToChange.discountPercentage = null;
        } else {
            elementToChange.discount = null;
        }
        this.expandKey++;
    }

    get invoiceId() {
        return this.invoice.id;
    }

    prevNext = {
        prev: "",
        next: "",
    };

    @Watch("invoiceId")
    async getPrevNext() {
        const companyId = this.companyId;
        // Implémenter le filtre
        const prefilter = {
            thirdPartyCompanyName: [...this.$store.state.invoiceFilter.clientCompaniesSelected],
            type: this.invoice.type,
            search: this.$store.state.invoiceFilter.search,
            status: this.$store.state.invoiceFilter.status,
        };
        const filter = getCommonInvoiceWhere(prefilter);

        const result = await this.$apollo.query({
            query: GET_PREV_NEXT_INVOICE,
            variables: {
                companyId: companyId,
                id: this.invoiceId,
                filter: filter,
            },
        });
        console.log(result.data.getPrevNextInvoice);
        // resolver
        this.prevNext = { ...result.data.getPrevNextInvoice };
    }

    get nextDisabled() {
        if (this.prevNext.next) {
            return false;
        }
        return true;
    }

    next() {
        const nextId = this.prevNext.next;
        if (!nextId) {
            return;
        }
        this.$router.replace({
            name: "invoiceEdition",
            params: {
                companyId: this.companyId,
                id: nextId,
            },
        });
    }

    get prevDisabled() {
        if (this.prevNext.prev) {
            return false;
        }
        return true;
    }

    prev() {
        const prevId = this.prevNext.prev;
        if (!prevId) {
            return;
        }
        this.$router.replace({
            name: "invoiceEdition",
            params: {
                companyId: this.companyId,
                id: prevId,
            },
        });
    }

    addSubtTotalLine() {
        const subTotal = {
            reference: "",
            title: "",
            description: "",
            type: "TOTAL",
            quantity: 0,
            untiPrice: 0,
            netAmount: 0,
            vatAmount: 0,
            grossAmount: 0,
            vatRate: 0,
            invoiceId: this.invoice.id,
            productId: "",
            engagmentLetterId: "",
            discountPercentage: 0,
            discount: 0,
        };
        this.invoice.lines.push(subTotal);
        console.log("invoice line", this.invoice.lines);
    }

    back() {
        this.$router.go(-1);
    }

    preview = 0;
    showPreviewToggle = false;

    @Watch("showPreviewToggle")
    showPreviewWindow() {
        this.preview = Number(this.showPreviewToggle);
    }

    @Apollo({
        query: INVOICE_THEMES,
        variables() {
            return {
                company: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        async specificResult({ data, loading }: any) {
            if (!loading) {
                if (
                    data?.invoiceThemes?.length &&
                    data.invoiceThemes[0].id &&
                    data.invoiceThemes[0].theme
                ) {
                    // // Necessary to unstructure the default value first so that new keys that are added to defaultInvoiceThemeSettings are also available in the loaded personnalized theme
                    // this.invoiceThemeSettings = {...this.invoiceThemeSettings, ...data.invoiceThemes[0].theme}
                    // // For compatibility with previous versions, we check if invoiceThemeSettings.tables.header.columns is null/undefined
                    // if (!this.invoiceThemeSettings.tables.header.columns) {
                    //     // Set to default value
                    //     this.invoiceThemeSettings.tables.header.columns = JSON.parse(JSON.stringify(InvoiceThemeService.getDefaultTableColumns()))
                    // }

                    this.invoiceThemeSettings = InvoiceThemeService.mergeWithDefaultSettings(
                        data.invoiceThemes[0].theme,
                    );
                    this.idTheme = data.invoiceThemes[0].id;
                    if (
                        data.invoiceThemes[0].background?.signedUrl &&
                        !this.invoiceThemeSettings?.page?.selectedDefaultBackgroundKey &&
                        this.invoiceThemeSettings?.page?.useBackgroundImage
                    ) {
                        this.backgroundImage = data.invoiceThemes[0].background.signedUrl;
                    } else {
                        await this.fetchBackgroundImage();
                    }
                    if (data.invoiceThemes[0].additionalDocument?.signedUrl) {
                        this.additionalDocument =
                            data.invoiceThemes[0].additionalDocument.signedUrl;
                    } else {
                        await this.fetchAdditionalDocument();
                    }
                }

                // console.log("Theme data", data)
            }
        },
    })
    invoiceThemeSettings = InvoiceThemeFrontService.originalTheme();

    generatedHtml = "";
    idTheme = null;
    backgroundImage = null;
    additionalDocument = null;

    async fetchBackgroundImage() {
        if (!this.invoiceThemeSettings?.page?.useBackgroundImage) {
            // Don't fetch if background is not used
            return;
        }
        if (this.invoiceThemeSettings?.page?.selectedDefaultBackgroundKey) {
            this.backgroundImage = (
                await InvoiceThemeFrontService.fetchDefaultBackground(
                    this.invoiceThemeSettings.page.selectedDefaultBackgroundKey,
                )
            )?.signedUrl;
        } else {
            if (!this.idTheme || this.idTheme.length === 0) {
                this.backgroundImage = null;
                return;
            }

            const response = await this.$apollo.query({
                query: GET_INVOICE_THEME_BACKGROUND,
                variables: {
                    id: this.idTheme,
                },
            });

            if (!response?.data?.getInvoiceThemeBackground?.signedUrl) {
                this.backgroundImage = null;
                return;
            }
            if (!this.invoiceThemeSettings?.page?.selectedDefaultBackgroundKey) {
                this.backgroundImage = response.data.getInvoiceThemeBackground.signedUrl;
            }
        }
    }

    async fetchAdditionalDocument() {
        if (!this.idTheme || this.idTheme.length === 0) {
            this.additionalDocument = null;
            return;
        }

        const response = await this.$apollo.query({
            query: GET_INVOICE_ADDITIONAL_DOCUMENT,
            variables: {
                id: this.idTheme,
            },
        });

        if (!response?.data?.getInvoiceThemeAdditionalDocument?.signedUrl) {
            this.additionalDocument = null;
            return;
        }
        this.additionalDocument = response.data.getInvoiceThemeAdditionalDocument.signedUrl;
    }

    invoiceDomInfo = "";

    async printInvoice() {
        console.log("status", this.invoice.status);
        if (this.invoice.status === "DRAFT") {
            const tempPreviewValue = this.preview;
            this.preview = 1;
            const interval = setInterval(async () => {
                if (this.$refs.invoicePreviewRef && this.invoiceDomInfo) {
                    this.preview = tempPreviewValue;
                    await this.$nextTick();
                    this.printPreview();
                    this.preview = tempPreviewValue;
                    clearInterval(interval);
                }
            }, 200);

            setTimeout(() => {
                // Clear interval if not cleared after 2 seconds
                this.preview = tempPreviewValue;
                clearInterval(interval);
            }, 2000);
        } else {
            await this.print();
        }
    }

    printPreview() {
        let htmlService;
        if (this.invoice?.type === "BILL_DELIVERY") {
            htmlService = new DeliveryNoteHtmlBuilder(
                true,
                this.invoiceThemeSettings,
                this.invoice,
                this.quotation,
                this.userCompany,
                this.previewScaleSize,
                true,
                this.backgroundImage,
                "",
                this.invoiceDomInfo,
            );
        } else {
            htmlService = new InvoiceHtmlViewService(
                true,
                this.invoiceThemeSettings,
                this.invoice,
                this.quotation,
                this.userCompany,
                this.previewScaleSize,
                true,
                this.backgroundImage,
                "",
                this.invoiceDomInfo,
            );
        }
        const html = htmlService.generateHtmlTemplate();
        // InvoiceThemeService.
        this.previewInvoiceInNewWindow({
            printingHtml: html,
            printDialog: true,
        });
    }

    previewInvoiceInNewWindow({ printingHtml, printDialog = false, openWindow = true }) {
        if (!printingHtml) {
            return;
        }
        try {
            // if (openWindow)
            const WinPrint = window.open(
                "",
                "",
                "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0",
            );

            WinPrint.document.write(printingHtml);
            if (printDialog) {
                WinPrint.onload = () => {
                    WinPrint.print();
                };
            }

            WinPrint.document.close();
        } catch (err) {
            console.error("Error in invoiceHtmlService.ts < previewInvoiceInNewWindow", err);
        }
    }

    get enableSignature() {
        if (!this.isQuote) {
            return false;
        }
        if (
            this.invoice.status.indexOf("ACCEPTED") === -1 &&
            this.invoice.status.indexOf("VALIDATED") === -1
        ) {
            return false;
        }
        return true;
    }

    get containsReceivers() {
        if (!this.invoice?.data?.receivers?.length) {
            return false;
        }
        if (!this.invoice.data.receivers[0].email) {
            return false;
        }

        return true;
    }

    get showValidateButton() {
        if (this.invoice.status === "DRAFT" || this.isSaving) {
            return true;
        }
        if (
            this.invoice.status === "BEING_VALIDATED" &&
            moment().diff(moment((this.invoice as any).updatedAt), "minutes") >= 5
        ) {
            return true;
        }
        return false;
    }
}

export default toNative(InvoiceEdition);
</script>

<style lang="scss" scoped>
.totals {
    font-weight: bold;
    font-size: 1em;
    line-height: 1.5em;
}
</style>
